import { render } from "./criteria-basic-interests.vue?vue&type=template&id=6f8062ea&scoped=true&ts=true"
import script from "./criteria-basic-interests.vue?vue&type=script&lang=ts"
export * from "./criteria-basic-interests.vue?vue&type=script&lang=ts"

import "./criteria-basic-interests.vue?vue&type=style&index=0&id=6f8062ea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8062ea"]])

export default __exports__